import { initialTopicInfoState } from 'mk2/apps/forum/containers/TopicInfo/TopicInfo.constants';
import { TopicInfoState } from 'mk2/apps/forum/containers/TopicInfo/TopicInfo.reducers';
import { AppState } from 'mk2/reducers';

export const getForumTopicInfoState = (state: AppState, slug: string): TopicInfoState =>
    state.containers.forum.forumTopicInfos[slug] || initialTopicInfoState;
